<template>
  <div :class="$style.headerWrapper">
    <div v-if="!isTransparent" :class="$style.shim"></div>
    <div
    :class="[$style.header, {[$style.transparent]: isTransparent}]"
    @click.stop>
    <div :class="$style.headerContainer">
      <div :class="$style.headerLeft">
        <a :href="geekbangServer">
          <img :class="$style.logo" :src="logo">
        </a>
        <!-- 菜单 -->
        <div :class="$style.menuList">
          <div
            :class="$style.menuItem"
            :key="gIndex"
            v-for="(group, gIndex) in menuList"
            @mouseenter="showSubmenu(group)"
            @mouseleave="hideSubmenu(group)"
            @click="jumpMenu(group)">
            {{ group.name }}
            <i class="iconfont icon-arrow" :class="$style.arrowIcon" v-if="group.submenu"></i>
            <!-- 子菜单 -->
            <div :class="$style.submenuListWrapper" v-if="group.showPop">
              <div :class="$style.submenuList">
                <div
                  :class="[$style.submenuItem, {[$style.disabled]: item.disabled}]"
                  :key="index"
                  v-for="(item, index) in group.submenu"
                  @click.stop="jump(item, group)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 登录注册 -->
      <div :class="$style.userInfo">
        <template v-if="loginUser">
          <img :class="$style.avatar" :src="loginUser.avatar" @click="isShowUserDropdown = !isShowUserDropdown">
          <div :class="[$style.userMenu, {[$style.on]: isShowUserDropdown}]">
            <div :class="$style.user">
              <div :class="$style.userName">{{ loginUser.nick }}</div>
              <div :class="$style.cellphone">{{ loginUser.cellphone }}</div>
            </div>
            <div :class="$style.userMenuItem" :key="index" v-for="(item, index) in userMenuList" @click.stop="userMenuClick">
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-else>
          <span :class="$style.login" @click="login">登录/注册</span>
        </template>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { login } from '@geekbang/time.sdk'
import config from '@/config'

import logo from '@/assets/img/logo/logo.png'
import logoWhite from '@/assets/img/logo/logo-white.png'
import { menuList } from './menu'

export default {
  data () {
    return {
      geekbangServer: config.geekbangServer,
      isShowUserDropdown: false,
      isTransparent: false,
      menuList,
      userMenuList: [
        { name: '极客时间', link: config.timeServer },
        { name: 'InfoQ', link: config.infoq },
        { name: '退出登录', link: `${config.accountServer}/logout?redirect=${encodeURIComponent(window.location.href)}` }
      ]
    }
  },
  computed: {
    ...mapState(['loginUser']),
    isHomePage () {
      return this.$route.name === 'home'
    },
    logo () {
      return this.isTransparent ? logoWhite : logo
    }
  },
  created () {
    if (this.isHomePage) {
      this.isTransparent = true
    }
  },
  mounted () {
    document.addEventListener('scroll', this.scrollHandler)
    document.addEventListener('click', this.clickHandler)
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.scrollHandler)
    document.removeEventListener('click', this.clickHandler)
  },
  methods: {
    clickHandler () {
      this.hideUserMenu()
    },

    scrollHandler () {
      this.hideUserMenu()
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.isHomePage) {
        // 超出视频区域后，不展示透明导航
        this.isTransparent = scrollTop < 600
      }
    },

    showSubmenu (item) {
      this.$set(item, 'showPop', true)
    },

    hideSubmenu (item) {
      this.$set(item, 'showPop', false)
    },

    hideUserMenu () {
      this.isShowUserDropdown = false
    },

    jump (item, group) {
      if (item.disabled) {
        return
      }

      if (item.replace) {
        window.location.href = item.link
      } else {
        window.open(item.link)
      }
      this.hideSubmenu(group)
    },

    jumpMenu (item) {
      window.open(item.link)
    },

    userMenuClick (item) {
      window.location.href = item.link
    },

    login () {
      login()
    }
  }
}
</script>

<style lang="scss" module>
.header {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background: #fff;
  user-select: none;
  transition: transform 0.2s ease;

  // 透明主题
  &.transparent {
    position: fixed;
    color: #fff;
    background: transparent;

    .menuItem {
      color: #fff;
    }
  }
}

.shim {
  height: 70px;
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
  height: 70px;
  margin: 0 auto;
}

.headerLeft {
  display: flex;
}

.logo {
  height: 36px;
}

.menuList {
  display: flex;
  align-items: center;
  margin-left: 25px;

  .menuItem {
    display: flex;
    position: relative;
    padding: 8px 15px;
    font-size: 15px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    cursor: pointer;
    white-space: nowrap;
    transition: color .2s;

    &:hover {
      color: #FA6400;
    }
  }
}

.arrowIcon {
  display: block;
  position: relative;
  top: 2px;
  transform: scale(.5);
  transform-origin: right;
  margin-left: -10px;
  opacity: .8;
}

.userInfo {
  position: relative;
  cursor: pointer;
  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
  }
}

.user {
  padding: 12px 16px;
  border-bottom: 1px solid #e9e9e9;

  .userName {
    font-size: 15px;
    font-weight: 500;
    color: #333333;
    line-height: 21px;
  }

  .cellphone {
    margin-top: 6px;
    font-size: 12px;
    color: #888888;
    line-height: 17px;
  }
}

.login {
  &:hover {
    color: #FA6400;
  }
}

.userMenu {
  position: absolute;
  top: 50px;
  right: 0;
  width: 130px;
  background: rgba(255,255,255,1);
  box-shadow: 0px 0px 14px 0px rgba(140,140,140,0.13);
  border-radius: 6px;
  opacity: 0;
  height: 0;

  &.on {
    transition: opacity .2s;
    opacity: 1;
    height: auto;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: -5px;
    right: 20px;
    width: 10px;
    height: 10px;
    background-color: #ffffff;
    transform: rotate(45deg);
    cursor: pointer;
    box-shadow:0px 0px 8px 3px rgba(139,162,192,0.13);
  }

  .userMenuItem {
    display: flex;
    padding-left: 16px;
    padding: 10px 0 10px 16px;
    line-height: 20px;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;

    &:hover {
      color: #FA6400;
      background: #FBF5EE;
    }

    &:last-child {
      border-top: 1px solid #e9e9e9;
      border-radius: 0 0 6px 6px;
    }
  }
}

.submenuListWrapper {
  position: absolute;
  z-index: 99;
  top: 0;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}

.submenuList {
  box-sizing: border-box;
  margin-top: 38px;
  background: #FFFFFF;
  box-shadow: 0px 8px 32px 0px rgba(206,211,226,0.24);
  border-radius: 6px;
  overflow: hidden;
}

.submenuItem {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 38px;
  font-size: 15px;
  font-weight: 400;
  color: #333;
  white-space: nowrap;

  &.on,
  &:hover {
    color: #FA6400;
    background: #FBF5EE;
  }

  &.disabled {
    opacity: .5;
    cursor: not-allowed;
  }
}
</style>
